import AppIcon from '../../../components/AppIcon';
import { formatNumber } from '../../../utils/formatNumber';

const CustomerInsightsPanel = ({ insights }) => {
  const insightCards = [
    {
      icon: 'Users',
      label: 'إجمالي العملاء',
      value: formatNumber(insights?.totalCustomers || 0),
      color: 'var(--color-primary)'
    },
    {
      icon: 'UserPlus',
      label: 'عملاء جدد هذا الشهر',
      value: formatNumber(insights?.newCustomers || 0),
      color: 'var(--color-success)'
    },
    {
      icon: 'Repeat',
      label: 'عملاء متكررون',
      value: formatNumber(insights?.repeatCustomers || 0),
      color: 'var(--color-accent)'
    },
    {
      icon: 'TrendingUp',
      label: 'معدل الاحتفاظ',
      value: `${insights?.retentionRate || 0}%`,
      color: 'var(--color-secondary)'
    },
    {
      icon: 'Calendar',
      label: 'متوسط الحجوزات لكل عميل',
      value: insights?.avgBookingsPerCustomer || 0,
      color: 'var(--color-primary)'
    },
    {
      icon: 'Star',
      label: 'متوسط رضا العملاء',
      value: `${insights?.avgSatisfaction || 0}/5`,
      color: 'var(--color-warning)'
    }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm mb-6 md:mb-8">
      <div className="mb-4">
        <h3 className="text-lg md:text-xl font-bold text-foreground mb-1">
          رؤى العملاء
        </h3>
        <p className="text-sm text-muted-foreground">
          تحليل سلوك العملاء ومعدلات الاحتفاظ والرضا
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {insightCards?.map((card, index) => (
          <div
            key={index}
            className="bg-background rounded-lg p-4 border border-border hover:shadow-warm-md transition-smooth"
          >
            <div className="flex items-center gap-3 mb-2">
              <div
                className="w-10 h-10 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${card?.color}15` }}
              >
                <AppIcon name={card?.icon} size={20} color={card?.color} />
              </div>
              <div className="flex-1">
                <p className="text-xs text-muted-foreground mb-1">{card?.label}</p>
                <p className="text-xl font-bold text-foreground">{card?.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerInsightsPanel;